export const createDaysState = (value: any)=>{
    return (dispatch: any) => {
        dispatch({
            type:"CREATE_DAYS_STATE",
            payload: value
        })
    }
} 

export const changeDayState = (value:any) => {
    return (dispatch:any) => {
        dispatch({
            type: "CHANGE_DAY_STATE",
            payload: value
        })
    }
}

export const changeAllDayState = (value:any) => {
    return (dispatch:any) => {
        dispatch({
            type: "CHANGE_ALL_DAY_STATE",
            payload: value
        })
    }
}

export const cleanDaysState = (value:any) => {
    return (dispatch:any) => {
        dispatch({
            type: "CLEAN_DAYS_STATE",
            payload: value
        })
    }
}
